import React, { useRef, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import './ServiceDescriptionModal.css';
import useFitText from '../hooks/useFitText';

const ServiceDescriptionModal = ({ service, onClose }) => {
  const titleRef = useRef();
  const descriptionRef = useRef();
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);

  useFitText(titleRef, { minFontSize: 20 });

  useEffect(() => {
    const checkScrollability = () => {
      const { current } = descriptionRef;
      if (current) {
        setShowScrollIndicator(current.scrollHeight > current.clientHeight);
      } else {
        setShowScrollIndicator(false);
      }
    };

    checkScrollability();
    window.addEventListener('resize', checkScrollability);
    const timeout = setTimeout(checkScrollability, 100);

    return () => {
      window.removeEventListener('resize', checkScrollability);
      clearTimeout(timeout);
    };
  }, [service]);

  if (!service) return null;

  const imageUrl = process.env.PUBLIC_URL + '/fondoexperiencias.png';

  return (
    <div className="service-modal-overlay" onClick={onClose}>
      <div
        className="service-modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundImage: `url(${imageUrl})`
        }}
      >
        <button className="service-modal-close-button" onClick={onClose}>X</button>
        <div className="title-container">
          <h2 ref={titleRef}>{service.name}</h2>
        </div>
        <div className="service-modal-description" ref={descriptionRef}>
          <ReactMarkdown>{service.description}</ReactMarkdown>
          {showScrollIndicator && (
            <div className="service-scroll-indicator">
              <span></span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ServiceDescriptionModal;